export default "__VITE_ASSET__I24ysnJC__"